import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const ReadyToStartProject = () => {
  useEffect(() => {
    // Initialiser AOS
    AOS.init({ duration: 1200 });
  }, []);

  return (
    <section
      data-aos="fade-up"
      id="contact"
      className="py-20 bg-gradient-to-r from-gray-800 to-gray-900 text-center"
    >
      <h2 className="text-5xl font-bold mb-12 text-yellow-400">
        Prêt à Démarrer Votre Projet ?
      </h2>
      <p className="text-2xl mb-14 max-w-3xl mx-auto">
        Contactez-nous dès aujourd'hui pour discuter de votre projet. Ensemble,
        faisons briller vos idées !
      </p>
      <a
        href="/contact"
        className="px-10 py-4 bg-gradient-to-r from-blue-500 to-blue-700 text-white text-xl font-semibold rounded-full shadow-lg hover:from-blue-600 hover:to-blue-800 transition duration-300"
      >
        Contactez-Nous
      </a>
    </section>
  );
};

export default ReadyToStartProject;
